import { socialApiClient } from '@/shared/api-client/social-api-client';

export async function EndCampaign(campaignId: string, signal?: AbortSignal): Promise<void> {
  await socialApiClient.patch(`campaigns/${campaignId}/end`, {
    signal,
  });
}
